;(function ($) {
    $.magicCols = {
        settings: {},
        init: function (settings) {
            let self = this;

            this.settings = settings;

            $(window).on('load', function () {
                self.getCols(settings);
            }).on('resize', function () {
                self.resetData(settings);
                self.getCols(settings);
            });
        },
        refresh() {
            this.resetData(this.settings);
            this.getCols(this.settings);
        },
        manual(settings) {
            this.settings = settings;
            this.getCols(settings);
        },
        getCols: function (settings) {
            if (typeof settings !== 'undefined' && typeof settings.col !== 'undefined') {
                let self = this,
                    colClass = settings.col,
                    tempOffsetTop = null,
                    rowCounter = 0,
                    colCounter = 0,
                    colLength = $(colClass).length;

                for (let i = 0; i < colLength; i++) {
                    let $this = $(colClass).eq(i),
                        offsetTop = $this.offset().top;

                    if (offsetTop !== tempOffsetTop && tempOffsetTop !== null) {
                        self.implementRowHeight(settings, rowCounter);

                        offsetTop = $this.offset().top;
                        colCounter = 0;
                        rowCounter++;
                    }

                    if (typeof self.colsData[rowCounter] === 'undefined') {
                        self.colsData[rowCounter] = [];
                    }

                    self.colsData[rowCounter][colCounter] = {
                        jq: $this,
                        offsetTop: offsetTop
                    };

                    colCounter++;
                    tempOffsetTop = offsetTop;

                    if (i+1 === colLength) {
                        self.implementRowHeight(settings, rowCounter);
                    }
                }

                self.colsData = [];
            }
        },
        implementRowHeight: function (settings, rowCounter) {
            let self = this;

            self.getChildren(settings, self.colsData[rowCounter], rowCounter);
            self.updateHeight(self.colsData[rowCounter]);
            self.compareHeight(self.colsData[rowCounter], rowCounter);
        },
        updateHeight: function (rowObj) {
            for (let col in rowObj) {
                if (rowObj.hasOwnProperty(col)) {
                    rowObj[col].jq.css({
                        'height': ''
                    });
                    rowObj[col].height = rowObj[col].jq.outerHeight();
                }
            }
        },
        getChildren: function (settings, rowObj, rowIndex) {
            if (typeof settings.children === 'object') {
                for (let block in settings.children) {
                    if (settings.children.hasOwnProperty(block)) {
                        let jqArray = [],
                            heightArray = [];

                        for (let col in rowObj) {
                            if (rowObj.hasOwnProperty(col)) {
                                let $childrenBlock = rowObj[col].jq.find(settings.children[block]);
                                jqArray.push(rowObj[col].jq.find($childrenBlock));
                                heightArray.push(rowObj[col].jq.find(settings.children[block]).outerHeight());
                            }
                        }

                        this.setHeight(jqArray, Math.max.apply(null, heightArray), rowIndex);
                    }
                }
            }
        },
        compareHeight: function (rowObj, rowIndex) {
            let heightArray = [],
                jqArray = [];

            for (let col in rowObj) {
                if (rowObj.hasOwnProperty(col)) {
                    heightArray.push(rowObj[col].height);
                    jqArray.push(rowObj[col].jq);
                }
            }

            this.setHeight(jqArray, Math.max.apply(null, heightArray), rowIndex);
        },
        setHeight: function (jqArray, height, rowIndex = null) {
            let setHeight = height+'px';

            if (jqArray.length === 1) {
                setHeight = '';
            }

            for (let jq in jqArray) {
                if (jqArray.hasOwnProperty(jq)) {
                    jqArray[jq].css({
                        'height': setHeight
                    });

                    if(this.settings.hasOwnProperty('callback') && rowIndex !== null && jq == 0) {
                        this.settings.callback(jqArray[jq], rowIndex, height, jq);
                    }
                }
            }
        },
        resetData: function (settings) {
            for (let item in settings) {
                if (settings.hasOwnProperty(item)) {

                    if (item === 'col') {
                        $(settings.col).css({
                            'height': ''
                        });
                    }

                    if (item === 'children') {
                        let children = settings[item];

                        for (let block in children) {
                            if (children.hasOwnProperty(block)) {
                                $(settings.col + ' ' + children[block]).css({
                                    'height': ''
                                });
                            }
                        }
                    }
                }
            }
        },
        colsData: []
    };
})(jQuery);